import { ExportSVGtoPNG, SVGRenderer } from "kadow-svg-utils";
import CONFIG from "../model/TSConfig";
import { DEFAULT_URL_FOR_QRCODE } from "./constants";

const svgRenderer = new SVGRenderer({
  jetpackFrontEndURL: CONFIG.jetpackFrontendUrl ?? "",
  defaultUrlForQRCode: DEFAULT_URL_FOR_QRCODE,
  imagePlaceholderUrl: CONFIG.image_placeholder_url ?? "",
  s3BucketUrl: CONFIG.cdn_url ?? "",
  log: false
});

const exportSVGToPNG = new ExportSVGtoPNG(CONFIG.cdn_url ?? "");

export { svgRenderer, exportSVGToPNG };
